import type { PropsWithChildren } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledNumberOfAddedFields } from "app/pages/sales-intelligence/modules/enrichment/containers/EnrichmentCsvContainer/style";
import { NUMBER_OF_ADDED_FIELDS_TEXT } from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";

type Props = PropsWithChildren<{
    numberOfSelectedItems: number;
}>;

const CompanyColumnPickerHead = ({ numberOfSelectedItems, children }: Props) => {
    return (
        <Flex
            justifyContent="space-between"
            margin="0 0 10px"
            padding="10px 0"
        >
            <StyledNumberOfAddedFields>
                {translate(NUMBER_OF_ADDED_FIELDS_TEXT, { number: numberOfSelectedItems })}
            </StyledNumberOfAddedFields>

            {children}
        </Flex>
    );
};

export default CompanyColumnPickerHead;
